import { Plan } from "../types";

const matchedPlan: (id: number, plans: Plan[]) => Plan | undefined = (id, plans) => plans.find(
  (plan: Plan) =>
    plan.productId ===
    id
);

export default matchedPlan